import { IApiResponse, IDistinctParams } from "../common/commonTypes";
import { fetchWrapper } from "../helpers/fetchWrapper";
import { createDistinctSequalizeUrl } from "../helpers/requestHelper";

export const distinctService = {
  fetchDistinct: async (params: IDistinctParams) => {
    const response: IApiResponse = await fetchWrapper.get(
      createDistinctSequalizeUrl(`distinct`, params)
    );
    return response;
  },
};
